/**
 * 左侧一级菜单图标配置
 *
 * 设计目的：
 * 后端 m_menu_group.icon 字段大量使用同一个图标（fa fa-th-large），
 * 导致左侧导航所有业务域长得一样，用户无法靠视觉快速区分。
 *
 * 工作机制：
 * 1. 纯前端映射，不改数据库、不改后端接口、不影响权限和菜单数据。
 * 2. 后端仍然下发 icon 字段，这里按"菜单名"做语义覆盖：
 *    - 命中映射表 -> 使用映射表里的语义化图标
 *    - 未命中     -> 回退到后端 icon（保持原有行为）
 * 3. 若后端 icon 为空或仍是重复的通用图标（fa fa-th-large / fa-flash / fa-desktop 等），
 *    统一回退到本文件里的 FALLBACK_ICON，避免出现"一排相同方块"。
 *
 * 注意事项：
 * - 只能使用 FontAwesome 4.7 已存在的类名（public/font-awesome/css/font-awesome.css），
 *   新增图标前请先在该 css 中确认 .fa-xxx:before 存在，否则图标位置会空白。
 * - 这里的 class 只影响图标，不影响菜单点击、路由跳转、权限判断。
 */

/** 后端下发图标为空/重复时的兜底图标 */
export const FALLBACK_ICON = 'fa fa-th'

/**
 * 业务域 -> FontAwesome 4.7 图标
 * key 为后端 m_menu_group.name（菜单组名称）
 */
const MENU_ICONS = {
    // —— 社区/物业基础 ——
  '小区': 'fa fa-home',
  '物业': 'fa fa-building',
  '组织': 'fa fa-sitemap',
  '员工管理': 'fa fa-users',
  '系统': 'fa fa-cogs',
  '系统管理': 'fa fa-cogs',
  '配置': 'fa fa-sliders',
  '缓存': 'fa fa-hdd-o',
  '菜单': 'fa fa-bars',
  '日志': 'fa fa-file-text-o',
  '任务': 'fa fa-tasks',

  // —— 房产/房屋 ——
  '房产': 'fa fa-building-o',
  '房产管理': 'fa fa-building-o',
  '房屋': 'fa fa-home',
  '合同': 'fa fa-file-text-o',
  '租赁': 'fa fa-book',
  '台账': 'fa fa-book',
  '资产管理': 'fa fa-archive',
  '资产': 'fa fa-archive',
  '库存': 'fa fa-archive',

  // —— 财务/收费 ——
  '财务': 'fa fa-money',
  '费用': 'fa fa-calculator',
  '财务报告': 'fa fa-line-chart',
  '财务报表': 'fa fa-line-chart',
  '报表': 'fa fa-bar-chart',
  '统计': 'fa fa-pie-chart',
  '收费': 'fa fa-cc',
  '账单': 'fa fa-calculator',
  '发票': 'fa fa-file-text-o',
  '优惠': 'fa fa-tags',
  '退款': 'fa fa-credit-card',
  '支付': 'fa fa-credit-card',

  // —— 车辆/停车 ——
  '停车': 'fa fa-car',
  '车位': 'fa fa-square',
  '门禁': 'fa fa-key',
  '道闸': 'fa fa-road',
  '车辆': 'fa fa-car',
  '充电': 'fa fa-bolt',

  // —— 设备/巡检/维修 ——
  '设备': 'fa fa-cogs',
  '保养': 'fa fa-wrench',
  '报修': 'fa fa-wrench',
  '维修': 'fa fa-wrench',
  '巡检': 'fa fa-clipboard',
  '巡楼': 'fa fa-street-view',
  '巡检路线': 'fa fa-map-o',
  '工单': 'fa fa-tasks',
  '工单管理': 'fa fa-tasks',

  // —— OA/办公 ——
  'OA': 'fa fa-briefcase',
  '办公': 'fa fa-briefcase',
  '审批': 'fa fa-check-square-o',
  '考勤': 'fa fa-clock-o',
  '公告': 'fa fa-bullhorn',
  '活动': 'fa fa-calendar',
  '会议': 'fa fa-comments',
  '信息发布': 'fa fa-bullhorn',
  '问卷投票': 'fa fa-pencil-square-o',
  '投诉建议': 'fa fa-commenting',

  // —— 商城/订单 ——
  '商城': 'fa fa-shopping-basket',
  '商品': 'fa fa-shopping-cart',
  '订单': 'fa fa-list-alt',
  '店铺': 'fa fa-shopping-basket',
  '会员': 'fa fa-user',
  '集采': 'fa fa-shopping-basket',

  // —— 预约/场地 ——
  '预约': 'fa fa-calendar',
  '场地': 'fa fa-calendar',
  '场地管理': 'fa fa-calendar',

  // —— 物业增值/ misc ——
  '服务': 'fa fa-life-ring',
  '供应商': 'fa fa-truck',
  '营销': 'fa fa-bullhorn',
  '数据中心': 'fa fa-database',
  '数据': 'fa fa-database',
  '客服': 'fa fa-comments',
  '投诉': 'fa fa-commenting',
  '巡更': 'fa fa-street-view',
  '监控': 'fa fa-video-camera',
  '门岗': 'fa fa-id-card',
  '梯控': 'fa fa-exchange',
  '路灯': 'fa fa-lightbulb-o',
  '水电': 'fa fa-tint',
  '水电费': 'fa fa-tint',
  '抄表': 'fa fa-tasks',
  '抄表管理': 'fa fa-tasks',
  '房屋管理': 'fa fa-home',
  '房屋类型': 'fa fa-home',
  '楼宇管理': 'fa fa-building-o',
  '房屋租赁': 'fa fa-book',
  '员工考勤': 'fa fa-clock-o',
  '维修保养': 'fa fa-wrench',
  '维修计划': 'fa fa-wrench',
  '工单流转': 'fa fa-tasks',
  '水电抄表': 'fa fa-tint',
  '报修工单': 'fa fa-wrench',
  '车辆管理': 'fa fa-car',
  '车位管理': 'fa fa-square',
  '费用管理': 'fa fa-calculator',
  '收银台': 'fa fa-cc',
  '停车场': 'fa fa-square',
  '充电桩': 'fa fa-bolt',
  '保洁': 'fa fa-trash-o',
  '绿化': 'fa fa-leaf',
  '安保': 'fa fa-shield',
  '客服中心': 'fa fa-comments',

  // —— 现网实际一级目录（按后端 m_menu_group.name 补充，P3-024）——
  // 说明：这些是线上真实下发的一级目录名，此前全部落到 fa-th 兜底图标，
  // 导致「一排相同方块」。此处按语义补齐。
  '小区信息': 'fa fa-home',
  '物业公司': 'fa fa-building',
  '地区': 'fa fa-map-o',
  '周边商家': 'fa fa-shopping-basket',
  '店铺信息': 'fa fa-shopping-basket',
  '小区店铺': 'fa fa-shopping-basket',
  '物业用户': 'fa fa-users',
  '物业员工': 'fa fa-user',
  '小区房屋': 'fa fa-building-o',
  '小区业主': 'fa fa-users',
  '小区车辆': 'fa fa-car',
  '小区费用项': 'fa fa-calculator',
  '设备台账': 'fa fa-hdd-o',
  '小区报修': 'fa fa-wrench',
  '小区巡检计划': 'fa fa-clipboard',
  '小区工作单': 'fa fa-tasks',
  '小区门禁': 'fa fa-key',
  '道闸相机': 'fa fa-video-camera',
  '水电表': 'fa fa-tint',
  '门禁出入': 'fa fa-key',
  '车辆出入': 'fa fa-car',
  '充电订单': 'fa fa-bolt',
  '水电充值': 'fa fa-tint',
  '运营分析': 'fa fa-line-chart',
  '小区费用汇总': 'fa fa-line-chart',
  '缴费记录': 'fa fa-cc',
  '小区欠费': 'fa fa-exclamation-circle',
  '受理单': 'fa fa-file-text-o',
  '登录日志': 'fa fa-file-text-o',
  '上架商品': 'fa fa-shopping-cart',
  '上架服务': 'fa fa-life-ring',
  '商城订单': 'fa fa-list-alt',
  '退货订单': 'fa fa-undo',
  '用户积分': 'fa fa-star',
  '积分交易': 'fa fa-exchange',
  '营销配置': 'fa fa-sliders',
  '营销方式': 'fa fa-bullhorn',
  '营销规则': 'fa fa-check-square-o',
  '营销黑名单': 'fa fa-ban',
  '营销记录': 'fa fa-file-text-o',
  '发布广告': 'fa fa-bullhorn',
  '制作优惠券': 'fa fa-tags',
  '金币设置': 'fa fa-cogs',
  '金币购买记录': 'fa fa-credit-card',
  '购买记录': 'fa fa-file-text-o',
  '运营': 'fa fa-line-chart'
}

/**
 * 后端下发图标里的"通用/占位"图标。
 * 这些图标本身没有业务语义，如果直接用会显得所有菜单一样，
 * 因此命中这些图标时，改为按菜单名查映射表；查不到再退回 FALLBACK_ICON。
 */
const GENERIC_ICONS = [
  'fa fa-th-large',
  'fa fa-th',
  'fa-flash',
  'fa-flask',
  'fa-desktop',
  'fa fa-globe',
  'fa fa-laptop',
  'fa fa-diamond'
]

/** 把后端 icon 拆成 class 数组，便于比较 */
function _splitIcon(icon) {
  return (icon || '').trim().split(/\s+/).filter(Boolean)
}

/**
 * 判断后端图标是否为"无语义占位图标"
 */
function _isGenericIcon(icon) {
  const classes = _splitIcon(icon)
  if (classes.length === 0) return true
  // 后端可能写成 "fa fa-th-large" 或 "fa-th-large"，做包含匹配
  return GENERIC_ICONS.some(g => {
    const gClasses = _splitIcon(g)
    return gClasses.every(c => classes.includes(c))
  })
}

/**
 * 获取左侧一级菜单的图标 class
 *
 * @param {Object} menu 后端下发的菜单组对象，至少包含 name / icon
 * @returns {String} FontAwesome class，例如 'fa fa-home'
 */
export function getMenuIcon(menu) {
  if (!menu) return FALLBACK_ICON

  const name = (menu.name || '').trim()
  const backendIcon = (menu.icon || '').trim()

  // 1. 后端图标本身有语义（不是通用占位图标）-> 尊重后端配置
  if (backendIcon && !_isGenericIcon(backendIcon)) {
    return backendIcon
  }

  // 2. 按菜单名查语义映射
  if (name && MENU_ICONS[name]) {
    return MENU_ICONS[name]
  }

  // 3. 按名称包含关系做模糊匹配（处理"XX管理""XX中心"等后缀）
  const fuzzy = _fuzzyMatch(name)
  if (fuzzy) return fuzzy

  // 4. 兜底
  return FALLBACK_ICON
}

/**
 * 名称模糊匹配：按 MENU_ICONS 的 key 长度倒序，优先匹配更具体的关键词
 */
function _fuzzyMatch(name) {
  if (!name) return null
  const keys = Object.keys(MENU_ICONS).sort((a, b) => b.length - a.length)
  for (const key of keys) {
    if (name.indexOf(key) !== -1) {
      return MENU_ICONS[key]
    }
  }
  return null
}

export default { getMenuIcon, FALLBACK_ICON }
